import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "block text-lg font-medium text-gray-900" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-600 text-xl"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormLabel',
  props: {
    name: {},
    isRequired: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
    (_ctx.isRequired)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
      : _createCommentVNode("", true)
  ]))
}
}

})